export default __webpack_public_path__ + "static/media/icon-error.67c91e95.svg";